import "./status-card-ticket.css"
import { faCircle } from '@fortawesome/free-regular-svg-icons'
import { faCalendar, faNoteSticky, faUser, faCircleInfo } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import moment from 'moment'
import React from 'react'

class StatusCardTicket extends React.Component {
  iconPositionHandler = () =>{
    const { status } = this.props;
    let iconClass = "icon"
    let iconContainerClass = "ms-2 me-4 d-flex flex-column"

    switch (status.stato) {
        case 0:
          iconClass += " text-success"
          iconContainerClass += " justify-content-end"
          break;
        case 2:
          iconClass += " text-danger"
          iconContainerClass += " justify-content-start"
          break;
        default:
          iconClass += " text-warning"
          iconContainerClass += " justify-content-center"
          break;
    }
    return {icon:iconClass, container:iconContainerClass}
  }

  render() {
    const { status, showDescription } = this.props;
    const classes = this.iconPositionHandler();

    return (
      <div className='d-flex status-history-content'>
        <div className={classes.container}>
          <div className={classes.icon}><FontAwesomeIcon icon={faCircle}/></div>
          <div className='vertical-line'/>
        </div>
        <div className='d-flex flex-column status-card-status'>
          <div className='d-flex align-items-center gap-2'>
            <FontAwesomeIcon icon={faNoteSticky}/>
            <p><b>{status.stato}</b></p>
          </div>
          <div className='d-flex align-items-center gap-2'>
            <FontAwesomeIcon icon={faUser}/>
            <p> {status?.operatore?.numMatricola}</p>
          </div>
          <div className='d-flex align-items-center gap-2'>
            <FontAwesomeIcon icon={faCalendar}/>
            <p>{moment(status.dataStato).format("DD/MM/YYYY")}</p>
          </div>
        </div>
        {showDescription && <div className='d-flex flex-column align-self-center align-items-center gap-2 status-card-description'>
          <FontAwesomeIcon icon={faCircleInfo}/>
          <p>{status.descrizione ? status.descrizione : "Nessuna descrizione"}</p>
        </div>}
      </div>
    )
  }
}

export default StatusCardTicket
